import { DataSource, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutOrderIdLookup extends Layout {
    sourceSettlementMovementLookup: DataSource;
    tableMovements: Table;
}
